export enum Currency {
    EUR = 'EUR',
    CHF = 'CHF',
}

export class CurrencyHelper {
    static getSymbol(currency: Currency): string {
        switch (currency) {
            case Currency.EUR:
                return '€';
            case Currency.CHF:
                return 'CHF';
            default:
                return '€';
        }
    }
}
